import { singleline } from "@core/foundation/string";
import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BILLING_SERVICE } from "../config/index.ts";
import {
  Reservation,
  ReservationMetadataSchema,
  Transaction,
} from "../models/index.ts";

export const billingInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${BILLING_SERVICE.LABEL}/int` },
  {
    commitReservation: apiEndpoint({
      body: z.object(
        {
          actualAmount: z.decimal().nonnegative(),
          description: Reservation.shape.description.optional(),
          metadata: ReservationMetadataSchema,
          principalId: Reservation.shape.principalId,
          reservationId: Reservation.shape.id,
        },
        {
          actualAmount: singleline`
            The credit to charge, as a decimal string, at most the reserved
            amount
          `,
          description: Reservation.descriptions.description,
          metadata: Reservation.descriptions.metadata,
          principalId: Reservation.descriptions.principalId,
          reservationId: Reservation.descriptions.id,
        },
      ),
      response: z.object(
        { transactions: z.array(Transaction.schema) },
        { transactions: "The transactions the charge deducted from balances" },
      ),
    }),
    createReservation: apiEndpoint({
      body: Reservation.createSchema.omit({
        expiresAt: true,
        metadataPrincipalId: true,
        status: true,
      }),
      response: z.object(
        { reservation: Reservation.schema },
        { reservation: "The reservation created, holding the credit" },
      ),
    }),
    releaseReservation: apiEndpoint({
      body: z.object(
        {
          principalId: Reservation.shape.principalId,
          reservationId: Reservation.shape.id,
        },
        {
          principalId: Reservation.descriptions.principalId,
          reservationId: Reservation.descriptions.id,
        },
      ),
      response: z.object({}),
    }),
  },
);
